import { z } from 'zod'
import { ACTION_ID_RE } from './ids'

export const ACTION_KINDS = ['primary', 'secondary', 'danger', 'row', 'nav'] as const
export type ActionKind = (typeof ACTION_KINDS)[number]

export const ACTION_SAFETIES = [
  'read-only',
  'mutating-disposable',
  'reversible',
  'forbidden-in-walk',
] as const
export type ActionSafety = (typeof ACTION_SAFETIES)[number]
export const ActionSafetySchema = z.enum(ACTION_SAFETIES)

export const ActionSchema = z.object({
  id: z.string().regex(ACTION_ID_RE, 'action id must be dotted/kebab segment'),
  kind: z.enum(ACTION_KINDS),
  /** Roles that may see this action; omit = all allow-roles on the screen. */
  roles: z.array(z.string().min(1)).optional(),
  capability_refs: z.array(z.string().min(1)).optional(),
  /** Opens another screen_id (modal or route). */
  opens: z.string().min(1).optional(),
  /** Preconditions (capability or seed tokens). */
  requires: z.array(z.string().min(1)).optional(),
  /** Driver registry key, e.g. auth.requestOtp — required when this action is executable. */
  driver: z.string().min(1).optional(),
  /** Safety classification — required when this action is executable. */
  safety: ActionSafetySchema.optional(),
  /** Explicit driver arguments — required (and may be empty) when executable. */
  args: z.record(z.string(), z.unknown()).optional(),
  label: z.string().min(1).optional(),
})

export type Action = z.infer<typeof ActionSchema>
